import React from 'react';
import { ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import FloorIcon from 'material-ui/svg-icons/action/line-weight';
import { Draggable } from 'react-beautiful-dnd';
import SidebarLink from '../../components/SidebarLink';
import style, { activeIconColor } from './style.js';

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // change background colour if dragging
  background: isDragging ? '#ededed' : '#fff',
  // styles we need to apply on draggables
  ...draggableStyle
});

export default class SidebarItemFloor extends React.Component {
  renderFloorContent() {
    const { facilityId, buildingId, floor, selected, edit } = this.props;
    const rootPath = edit ? 'facilities' : 'map';
    return (
      <ListItem
        containerElement={
          <SidebarLink
            to={`/${rootPath}/${facilityId}/buildings/${buildingId}/floors/${
              floor._id
            }`}
          />
        }
        rightIcon={<FloorIcon color={selected ? activeIconColor : ''} />}
        key={floor._id}
        innerDivStyle={style.nestedFloor}
        style={selected ? style.activeFloor : {}}
        disabled={selected}
      >
        {floor.name}
      </ListItem>
    );
  }
  render() {
    const { floor, index, edit } = this.props;
    if (edit) {
      return (
        <Draggable key={floor._id} draggableId={floor._id} index={index}>
          {(provided, snapshot) => (
            <div>
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={getItemStyle(
                  snapshot.isDragging,
                  provided.draggableProps.style
                )}
              >
                {this.renderFloorContent()}
                <Divider />
              </div>
              {provided.placeholder}
            </div>
          )}
        </Draggable>
      );
    }
    return this.renderFloorContent();
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/SidebarItemFloor/index.jsx